import Input from "decorator-form/dist/decorators/input/Input";
import { Entity } from "typegraph";
import Field from "typegraph/dist/decorators/field/Field";
import InputType from "../../../common/form/InputType";
import DropdownSelect from "../../../common/form/widgets/common/DropdownSelect";
import Category from "./Category";
import Topic from "./Topic";

const DigestOptions = DropdownSelect.registerWithOptions([
	{
		value: "none",
		label: "Never"
	},
	{
		value: "immediate",
		label: "Immediately"
	},
	{
		value: "daily",
		label: "Daily"
	},
	{
		value: "weekly",
		label: "Weekly"
	}
]);

@Entity({one: "topicSubscription", many: "topicSubscriptionsUser", create: "topicSubscriptionCreate", update: "topicSubscriptionUpdate", delete: "topicSubscriptionDelete"})
export class TopicSubscription {

	@Field()
	id: number;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Instant Notification"})
	instant: boolean = true;

	user: number;

	topic: number;

	// temporary untill the graphql api supports the same type for both mutations and queries
	@Field({aliasFor: "topic", entity: Topic})
	topicEntity: Topic;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Recieve Emails"})
	emailNotification: boolean = true;

	@Field()
	@Input({type: DigestOptions, title: "Send a notification summary email", required: true})
	digest: string;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/TopicSubscription.ts